<template>
  <div class="to-join-apply">
    <div style="width: 100%; margin-left: 10px">
      <div>
        <el-input
            v-model="query.companyName"
            placeholder="公司名称"
            style="width: 200px"
            class="query-item"
            clearable
            @clear="handleSearch"
        ></el-input>
        <el-button
            type="primary"
            class="query-item"
            @click="handleSearch"
        >
          搜索
        </el-button>
      </div>

      <el-table
          :data="tableData"
          height="580"
          stripe
          border
          v-loading="tableLoading"
          class="table"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '0' }"
          header-cell-class-name="table-header">
        <el-table-column prop="companyName" label="公司名" width="220" show-overflow-tooltip/>
        <el-table-column label="负责人" width="180" show-overflow-tooltip>
          <template #default="scope">
            <span>{{ [scope.row.directorName, scope.row.phone].filter(Boolean).join(' - ') || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="省市县" width="220" show-overflow-tooltip>
          <template #default="scope">
            <span>{{ [scope.row.pro, scope.row.city, scope.row.area].filter(Boolean).join(' - ') || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="areaName" label="校区名称" width="160" show-overflow-tooltip/>
        <el-table-column label="详细地址" min-width="220" show-overflow-tooltip>
          <template #default="scope">
            <span
                class="link-text"
                :class="{ 'is-disabled': !scope.row.latitude || !scope.row.longitude }"
                @click="openMap(scope.row)"
            >{{ scope.row.address || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="expiryTime" label="合同到期时间" width="160"/>
        <el-table-column label="合同章" width="110" align="center">
          <template #default="scope">
            <el-image
                v-if="scope.row.contractChapterImage"
                :src="scope.row.contractChapterImage"
                :preview-src-list="[scope.row.contractChapterImage]"
                fit="cover"
                style="width: 40px; height: 40px; border-radius: 4px;margin-top: 6px"
            >
              <div class="image-slot">无图</div>
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="收据章" width="110" align="center">
          <template #default="scope">
            <el-image
                v-if="scope.row.receiptChapterUrl"
                :src="scope.row.receiptChapterUrl"
                :preview-src-list="[scope.row.receiptChapterUrl]"
                fit="cover"
                style="width: 40px; height: 40px; border-radius: 4px"
            >
              <div class="image-slot">无图</div>
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right" align="center">
          <template #default="scope">
            <el-popconfirm
                v-if="scope.row.state === 0"
                title="确认开通该账号？"
                confirm-button-text="开通"
                cancel-button-text="取消"
                @confirm="handlePass(scope.row)"
            >
              <template #reference>
                <el-button type="text" size="small" style="padding: 0; margin: 0; color: #67C23A">开通账号</el-button>
              </template>
            </el-popconfirm>
            <el-popconfirm
                v-else-if="scope.row.state === 1"
                title="确认关闭该账号？"
                confirm-button-text="关闭"
                cancel-button-text="取消"
                @confirm="handleStop(scope.row)"
            >
              <template #reference>
                <el-button type="text" size="small" style="padding: 0; margin: 0; color: #F56C6C">关闭账号</el-button>
              </template>
            </el-popconfirm>
            <span v-else-if="scope.row.state === 2" style="color: #909399">账号已停</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
            border
            layout="total, prev, pager, next"
            :current-page="query.pageIndex"
            :page-size="query.pageSize"
            :total="pageTotal"
            @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {toJoinApplyList,pass,stopAccount} from "../../api/sysUser";

export default {
  name: "ToJoinApply",
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10,
        companyName: null,
      },
      tableData: [],
      pageTotal: 0,
      tableLoading: false,
    };
  },
  methods: {
    getData() {
      this.tableLoading = true;
      toJoinApplyList(this.query)
          .then((val) => {
            this.tableLoading = false;
            if (val.code === 200) {
              this.tableData = (val.data && val.data.records) || [];
              this.pageTotal =
                  (val.data && val.data.total) || this.tableData.length;
            } else {
              this.$message.error(val.message || "获取待加入申请列表失败");
            }
          })
          .catch(() => {
            this.tableLoading = false;
          });
    },
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.getData();
    },
    handleSearch() {
      this.query.pageIndex = 1;
      this.getData();
    },
    /**
     * 操作列：开通账号（state 0）
     */
    handlePass(row) {
      const id = row.id;
      if (!id) {
        this.$message.warning("该记录缺少 id，无法操作");
        return;
      }
      pass(id).then((res) => {
          if (res.code === 200) {
            this.$message.success("开通账号成功");
            this.getData();
          } else {
            this.$message.error(res.message || "开通账号失败");
          }
        })
        .catch(() => {
          this.$message.error("开通账号失败");
        });
    },
    /**
     * 操作列：关闭账号（state 1）
     */
    handleStop(row) {
      const id = row.id;
      if (!id) {
        this.$message.warning("该记录缺少 id，无法操作");
        return;
      }
      stopAccount(id)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("关闭账号成功");
            this.getData();
          } else {
            this.$message.error(res.message || "关闭账号失败");
          }
        })
        .catch(() => {
          this.$message.error("关闭账号失败");
        });
    },
    /**
     * 点击打开腾讯地图（网页版）；缺经纬度不跳转
     */
    openMap(row) {
      const lat = row.latitude;
      const lng = row.longitude;
      if (!lat || !lng) {
        this.$message.warning("该记录缺少经纬度信息");
        return;
      }
      const url = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${lat},${lng};title:校区位置&referer=yanhuo_admin`;
      window.open(url, "_blank");
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.to-join-apply {
  background-color: #ffffff;
  padding: 20px;
}

.query-item {
  margin: 20px 10px;
}

.pagination {
  margin: 20px 10px;
}

.link-text {
  color: #409eff;
  cursor: pointer;
}

.link-text.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  font-size: 12px;
  color: #909399;
  background: #f5f7fa;
  border-radius: 4px;
}
</style>
